module.exports = __webpack_public_path__ + "img/Pic_Banner-2.4160aecd.jpg";